import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Collapse } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import { LSgetItem, adminList } from '../../lib/common';

class Sidebar extends Component {

  state = {};

  toggleMenuState(menuState) {
    if (this.state[menuState]) {
      this.setState({ [menuState]: false });
    } else if (Object.keys(this.state).length === 0) {
      this.setState({ [menuState]: true });
    } else {
      Object.keys(this.state).forEach(i => {
        this.setState({ [i]: false });
      });
      this.setState({ [menuState]: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  componentDidMount() {
    this.setState({ adminType: LSgetItem("adminType") })
  }

  onRouteChanged() {
    document.querySelector('#sidebar').classList.remove('active');
    Object.keys(this.state).forEach(i => {
      this.setState({ [i]: false });
    });

    const dropdownPaths = [
      { path: '/apps', state: 'appsMenuOpen' },
      { path: '/basic-ui', state: 'basicUiMenuOpen' },
      { path: '/form-elements', state: 'formElementsMenuOpen' },
      { path: '/tables', state: 'tablesMenuOpen' },
      { path: '/icons', state: 'iconsMenuOpen' },
      { path: '/charts', state: 'chartsMenuOpen' },
      { path: '/user-pages', state: 'userPagesMenuOpen' },
      { path: '/error-pages', state: 'errorPagesMenuOpen' },
    ];

    dropdownPaths.forEach((obj => {
      if (this.isPathActive(obj.path)) {
        this.setState({ [obj.state]: true })
      }
    }));

  }

  render() {
    return (
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
          <a className="sidebar-brand brand-logo" href="index.html"><img src={require('../../assets/images/logo.svg')} alt="logo" /></a>
          <a className="sidebar-brand brand-logo-mini" href="index.html"><img src={require('../../assets/images/logomob.svg')} alt="logo" /></a>
        </div>
        <ul className="nav">

          <li className="nav-item nav-category">
          </li>
          <li className={this.isPathActive('/dashboard') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
            <Link className="nav-link" to="/dashboard">
              <span className="menu-icon"><i className="mdi mdi-speedometer"></i></span>
              <span className="menu-title"><Trans>Dashboard</Trans></span>
            </Link>
          </li>


          <li className={this.isPathActive('/tables') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
            <Collapse in={true}>
              <div>
                <ul className="nav flex-column sub-menu">
                  {LSgetItem("adminType") == adminList[0] && <li className="nav-item"> <Link className={this.isPathActive('/projectList') ? 'nav-link active' : 'nav-link'} to="/projectList"><Trans>Project List</Trans></Link></li>}
                  {LSgetItem("adminType") == adminList[0] && <li className="nav-item"> <Link className={this.isPathActive('/KycList') ? 'nav-link active' : 'nav-link'} to="/KycList"><Trans>KYC List</Trans></Link></li>}
                  {LSgetItem("adminType") == adminList[0] && <li className="nav-item"> <Link className={this.isPathActive('/KYTList') ? 'nav-link active' : 'nav-link'} to="/KYTList"><Trans>KYT List</Trans></Link></li>}
                  {LSgetItem("adminType") == adminList[3] && <li className="nav-item"> <Link className={this.isPathActive('/KYTList') ? 'nav-link active' : 'nav-link'} to="/KYTList"><Trans>KYT List</Trans></Link></li>}
                  {(LSgetItem("adminType") == adminList[0] || LSgetItem("adminType") == adminList[3]) && <li className="nav-item"> <Link className={this.isPathActive('/userlist') ? 'nav-link active' : 'nav-link'} to="/userlist"><Trans>User List</Trans></Link></li>}
                  {LSgetItem("adminType") == adminList[0] && <li className="nav-item"> <Link className={this.isPathActive('/feedList') ? 'nav-link active' : 'nav-link'} to="/feedList"><Trans>News and Feed list</Trans></Link></li>}
                  {(LSgetItem("adminType") == adminList[0] || LSgetItem("adminType") == adminList[1]) && <li className="nav-item"> <Link className={this.isPathActive('/cmshomelist') ? 'nav-link active' : 'nav-link'} to="/cmshomelist"><Trans>Cms List</Trans></Link></li>}
                  {LSgetItem("adminType") == adminList[0] && <li className="nav-item"> <Link className={this.isPathActive('/refferalFee') ? 'nav-link active' : 'nav-link'} to="/refferalFee"><Trans>Refferal Fees Management</Trans></Link></li>}
                  {LSgetItem("adminType") == adminList[0] && <li className="nav-item"> <Link className={this.isPathActive('/referral-management') ? 'nav-link active' : 'nav-link'} to="/referral-management"><Trans>Refferal Management</Trans></Link></li>}
                  {((LSgetItem("adminType") !== adminList[3]) && LSgetItem("adminType") !== adminList[1]) && <li className="nav-item"> <Link className={this.isPathActive('/mintReport') ? 'nav-link active' : 'nav-link'} to="/mintReport"><Trans>Collection mint report</Trans></Link></li>}
                  {((LSgetItem("adminType") !== adminList[3]) && LSgetItem("adminType") !== adminList[1]) && <li className="nav-item"> <Link className={this.isPathActive('/marketPlaceReport') ? 'nav-link active' : 'nav-link'} to="/marketPlaceReport"><Trans>Marketplace activity report</Trans></Link></li>}
                  {((LSgetItem("adminType") !== adminList[3]) && LSgetItem("adminType") !== adminList[1]) && <li className="nav-item"> <Link className={this.isPathActive('/royaltyReport') ? 'nav-link active' : 'nav-link'} to="/royaltyReport"><Trans>Marketplace royalty report</Trans></Link></li>}
                  {((LSgetItem("adminType") !== adminList[3]) && LSgetItem("adminType") !== adminList[1]) && <li className="nav-item"> <Link className={this.isPathActive('/stackProjects') ? 'nav-link active' : 'nav-link'} to="/stackProjects"><Trans>Stake Projects</Trans></Link></li>}
                  {((LSgetItem("adminType") !== adminList[3]) && LSgetItem("adminType") !== adminList[1]) && <li className="nav-item"> <Link className={this.isPathActive('/rewardProjects') ? 'nav-link active' : 'nav-link'} to="/rewardProjects"><Trans>Reward Projects</Trans></Link></li>}
                  {((LSgetItem("adminType") !== adminList[3]) && LSgetItem("adminType") !== adminList[1]) && <li className="nav-item"> <Link className={this.isPathActive('/projectRewards') ? 'nav-link active' : 'nav-link'} to="/projectRewards"><Trans>Reward History</Trans></Link></li>}
                  {LSgetItem("adminType") == adminList[0] && <li className="nav-item"> <Link className={this.isPathActive('/currencylist') ? 'nav-link active' : 'nav-link'} to="/currencylist"><Trans>Currency list</Trans></Link></li>}
                  {LSgetItem("adminType") == adminList[0] && <li className="nav-item"> <Link className={this.isPathActive('/whitelists') ? 'nav-link active' : 'nav-link'} to="/whitelists"><Trans>Whitelist Users</Trans></Link></li>}
                  {LSgetItem("adminType") == adminList[0] && <li className="nav-item"> <Link className={this.isPathActive('/adminList') ? 'nav-link active' : 'nav-link'} to="/adminList"><Trans>Admin role List</Trans></Link></li>}
                  {LSgetItem("adminType") == adminList[0] && <li className="nav-item"> <Link className={this.isPathActive('/email-template-list') ? 'nav-link active' : 'nav-link'} to="/email-template-list"><Trans>Email Templates</Trans></Link></li>}
                  {LSgetItem("adminType") == adminList[0] && <li className="nav-item"> <Link className={this.isPathActive('/notification-list') ? 'nav-link active' : 'nav-link'} to="/notification-list"><Trans>Notifications</Trans></Link></li>}
                </ul>
              </div>
            </Collapse>
          </li>
        </ul>
      </nav>
    );
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }

  componentDidMount() {
    this.onRouteChanged();
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    const body = document.querySelector('body');
    document.querySelectorAll('.sidebar .nav-item').forEach((el) => {

      el.addEventListener('mouseover', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });
  }

}

export default withRouter(Sidebar);
